module.exports = __webpack_public_path__ + "144cc79356820a02eef8852e60ed3fa6.svg";